import {ReactNode} from 'react'

type PageHeaderProps = {
  title: string
  description?: string
  eyebrow?: string
  actions?: ReactNode
}

const PageHeader = ({title, description, eyebrow, actions}: PageHeaderProps) => {
  return (
    <header className='ui-page-header'>
      <div className='ui-page-header-copy'>
        {eyebrow && <span className='ui-page-eyebrow'>{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className='ui-page-actions'>{actions}</div>}
    </header>
  )
}

export {PageHeader}
export type {PageHeaderProps}
